import { ProductSaving } from 'types/types';

export interface AlgoliaSearchResult {
  id: string;
  brand: string;
  name: string;
  formattedPrice: string;
  image: string;

  // optional
  shortName?: string;
  savings?: ProductSaving | null;
  formattedRetail?: string;
  isSoldOut?: boolean;
  isPromotionalDeal?: boolean;

  // tracking
  objectID?: string;
  __queryID?: string;
  __position?: number;

  // unused
  price?: unknown;
  retail?: unknown;
  categories?: unknown;
  description?: unknown;
  displayRetail?: unknown;
}

const isValidSaving = (saving: unknown): saving is ProductSaving =>
  saving !== null &&
  typeof (saving as ProductSaving) === 'object' &&
  typeof (saving as ProductSaving).format === 'string' &&
  typeof (saving as ProductSaving).percent === 'number' &&
  typeof (saving as ProductSaving).fixed === 'object' &&
  typeof (saving as ProductSaving).fixed.value === 'number';

export const isValidHit = (item: unknown): item is AlgoliaSearchResult =>
  typeof (item as AlgoliaSearchResult) === 'object' &&
  typeof (item as AlgoliaSearchResult).id === 'string' &&
  typeof (item as AlgoliaSearchResult).brand === 'string' &&
  typeof (item as AlgoliaSearchResult).name === 'string' &&
  typeof (item as AlgoliaSearchResult).formattedPrice === 'string' &&
  typeof (item as AlgoliaSearchResult).image === 'string' &&
  (item as AlgoliaSearchResult).shortName !== null &&
  ['undefined', 'string'].includes(
    typeof (item as AlgoliaSearchResult).shortName
  ) &&
  (item as AlgoliaSearchResult).formattedRetail !== null &&
  ['undefined', 'string'].includes(
    typeof (item as AlgoliaSearchResult).formattedRetail
  ) &&
  (item as AlgoliaSearchResult).isSoldOut !== null &&
  ['undefined', 'boolean'].includes(
    typeof (item as AlgoliaSearchResult).isSoldOut
  ) &&
  (item as AlgoliaSearchResult).isPromotionalDeal !== null &&
  ['undefined', 'boolean'].includes(
    typeof (item as AlgoliaSearchResult).isPromotionalDeal
  ) &&
  (item as AlgoliaSearchResult).objectID !== null &&
  ['undefined', 'string'].includes(
    typeof (item as AlgoliaSearchResult).objectID
  ) &&
  (item as AlgoliaSearchResult).__queryID !== null &&
  ['undefined', 'string'].includes(
    typeof (item as AlgoliaSearchResult).__queryID
  ) &&
  (item as AlgoliaSearchResult).__position !== null &&
  ['undefined', 'number'].includes(
    typeof (item as AlgoliaSearchResult).__position
  );

export interface SearchResult {
  id: string;
  brand: string;
  name: string;
  price: string;
  image: string;

  // optional
  shortName?: string;
  formattedRetail?: string;
  savings?: ProductSaving;
  isSoldOut?: boolean;
  isPromotionalDeal?: boolean;

  // tracking
  objectID?: string;
  queryID?: string;
  searchIndexPosition?: number;
}

export const transformSearchResult = (
  res: AlgoliaSearchResult
): SearchResult => ({
  id: res.id,
  brand: res.brand,
  name: res.name,
  price: res.formattedPrice,
  image: res.image,
  shortName: res.shortName,
  savings: isValidSaving(res.savings) ? res.savings : undefined,
  isSoldOut: res.isSoldOut,
  isPromotionalDeal: res.isPromotionalDeal,
  objectID: res.objectID,
  queryID: res.__queryID,
  searchIndexPosition: res.__position,
});
